import { Navigate, useLocation } from "react-router";

import { useScopeParams } from "@/hooks/useScopeParams";

import {
  METRICS_SCREEN_VIEW,
  METRIC_URL_PARAM,
  PORTFOLIO_METRIC_PANELS,
  SCREEN_VIEW_URL_PARAM,
} from "./portfolioMetricPanels";

/**
 * Keeps the retired `/portfolio/<metric>` links working by sending them to the
 * matching rail selection on the Trials page.
 */
export default function PortfolioMetricRedirect() {
  const { buildUrl } = useScopeParams();
  const { pathname } = useLocation();

  const requestedKey = pathname.split("/").filter(Boolean).pop();
  const panel = PORTFOLIO_METRIC_PANELS.find(
    (candidate) => candidate.key === requestedKey,
  );

  if (!panel) return <Navigate to={buildUrl("trials")} replace />;

  return (
    <Navigate
      to={buildUrl(
        `trials?${SCREEN_VIEW_URL_PARAM}=${METRICS_SCREEN_VIEW}&${METRIC_URL_PARAM}=${panel.key}`,
      )}
      replace
    />
  );
}
